import moment from "moment";
import { useCallback, useContext, useEffect, useState } from "react";
import "./home.scss";
import Sidebar from "../../../shared/components/sidebar/Sidebar";
import Navbar from "../../../shared/components/navbar/Navbar";
import Chart from "../../../shared/components/chart/Chart";
import { AuthContext } from "../../../shared/context/auth-context";
import { ClinicaContext } from "../../../shared/context/clinica-context";
import { useHttpClient } from "../../../shared/hooks/http-hook";
import toast from "react-hot-toast";
import PdfListaAtendimentos from "../../../shared/components/PdfGenerator/PdfListaAtendimentos/PdfListaAtendimentos";
import DashboardIcon from "@mui/icons-material/Dashboard";

import ModalInfo from "../../../shared/components/UIElements/ModalInfo";

import AvaliacoesPorEfetuarModal from "./components/AvaliacoesPorEfetuarModal";
import UrgenciasModal from "./components/UrgenciasModal";
import ModalDispensarUrgencia from "../../../shared/components/urgencia/ModalDispensarUrgencia";

import Tasks from "../components/tasks/Tasks";
import InformacoesDaClinica from "../components/informacoesDaClinica/InformacoesDaClinica";

import Procedimentos from "./components/Procedimentos";
import { useLoading } from "../../../shared/context/LoadingContext";
import "../components/top5tratamentos/Top5tratamentos.scss";
import "../../../shared/css/Checkbox.scss";
import { useWebSocketSubscription } from "../../../shared/context/websocket-context";
import ProcedimentosTratamento from "./components/ProcedimentosTratamento";

const DAILY_MESSAGES = [
  "Que hoje o motor funcione, o paciente colabore e o café nunca acabe!",
  "Sorriso no rosto, luvas nas mãos e fé que o paciente não desmaie!",
  "Hoje o plano é simples: anestesia pega, raio-x não falha e a impressora coopera!",
  "Que teus pacientes sejam pontuais e teus instrumentos, fiéis!",
  "Se o motor travar, respira fundo: o humor não pode travar junto!",
  "Mais um dia para provar que curar também é arte!",
  "Hoje o bisturi brilha e o stress fica na autoclave!",
  "Que o único sangramento do dia seja o da gengiva — e o mínimo possível!",
  "Hoje é dia de salvar sorrisos e evitar dramas!",
  "Lembra: cada paciente é único — e quase todos dizem 'não vai doer, né?'",
  "Que tua agenda flua melhor que resina recém-polida!",
  "Hoje você é o herói mascarado da saúde bucal!",
  "Nada como começar o dia com mãos firmes e paciência renovada!",
  "Que o som do motor te inspire, não te assuste!",
  "Que teu humor dure mais que o efeito da anestesia!",
  "Lembra: um sorriso bem feito vale mais que mil planilhas!",
  "Hoje é dia de brilhar — sem esquecer o protetor facial!",
  "Que teus atendimentos sejam leves e as consultas, certeiras!",
  "Se o dia apertar, lembra: até o dente do siso nasce com dificuldade!",
  "Sorrir é terapêutico — e tu receitas isso todo dia!",
  "Que teu foco seja tão preciso quanto tua lâmina!",
  "Hoje o diagnóstico vem fácil e o paciente entende na primeira!",
  "Lembra: o verdadeiro milagre é o paciente dizer 'não doeu nada'!",
  "Que o teu consultório seja mais zen que sala de yoga!",
  "Hoje a meta é simples: menos urgências, mais gratidão!",
  "Que tuas mãos curem, teus olhos percebam e teu humor contagie!",
  "Nada como um bom atendimento para restaurar dentes e ânimos!",
  "Que o motor gire, o plano aprove e o sorriso apareça!",
  "Hoje é dia de espalhar saúde — e um pouquinho de luz pelo consultório!",
  "Lembra: um bom profissional não perde o foco... nem o fio dental!",
  "Que teu dia seja leve, produtivo e cheio de sorrisos sinceros — inclusive o teu!",
];

function HomeMedicoAdministrador() {
  const { startLoading, stopLoading } = useLoading();

  const { sendRequest } = useHttpClient();
  const auth = useContext(AuthContext);
  const clinica = useContext(ClinicaContext);
  const [urgencias, setUrgencias] = useState();
  const [openModalUrgencia, setOpenModalUrgencia] = useState(false);
  const [openModalAvaliacoesPorEfetuar, setOpenModalAvaliacoesPorEfetuar] =
    useState(false);

  const [avaliacoesPorEfetuar, setAvaliacoesPorEfetuar] = useState([]);
  const [estatisticaDeProcedimentos, setEstatisticaProcedimentos] = useState(
    []
  );
  const [listaAtendimentoData, setListaAtendimentoData] = useState({
    show: false,
  });
  const [listaPresenca, setListaPresenca] = useState([]);
  const [modalProps, setModalProps] = useState({
    show: false,
    icon: "",
    title: "",
    message: "",
    form: false,
  });

  /* A lista das urgencias e sempre pedida ao servidor, nunca montada no
     cliente: e o servidor que sabe quais estao abertas, de que unidade, e o que
     cada uma tem. */
  const recarregarUrgencias = useCallback(async () => {
    try {
      const responseData = await sendRequest(
        /* `escopo=dia`: tudo o que se passou hoje, atendido ou dispensado, e
           nao apenas quem espera. A faixa do topo usa o omisso (`abertas`),
           que e o que um aviso vermelho deve contar. Aqui a pergunta e outra —
           quem chega a meio da tarde quer saber como foi a manha. */
        `${process.env.REACT_APP_BACKEND_LINK}/api/urgencias/clinica/${clinica.clinica._id}?escopo=dia`,
        "GET",
        null,
        {
          Authorization: "Bearer " + auth.token,
        }
      );
      setUrgencias(responseData.urgencias || []);
    } catch (err) {}
  }, [sendRequest, clinica.clinica._id, auth.token]);

  /* O cartao conta quem AINDA espera, nao as urgencias do dia.
     O numero fica carmesim quando ha trabalho por fazer — se contasse as
     atendidas, ficava vermelho a tarde toda por causa da manha, e um aviso
     que esta sempre ligado deixa de ser um aviso. */
  /* `{ id, nome }` da urgencia a dispensar, ou `null`. */
  const [aDispensar, setADispensar] = useState(null);
  const [dispensando, setDispensando] = useState(false);

  const urgenciasPendentes = (urgencias || []).filter(
    (u) => !u.atendido && u.ativo !== false
  );

  useWebSocketSubscription(
    async (parsedSocketData) => {
      /* Qualquer mexida nas urgencias faz recarregar a lista inteira.
       *
       * Antes montava-se a linha a mao a partir do documento do socket, o que
       * deixava de fora tudo o que a lista passou a mostrar (motivo,
       * descricao, quem marcou, quem foi avisado) e obrigava a um pedido do
       * cliente por cada urgencia.
       *
       * E o ramo de `delete` deixou de disparar: cancelar uma urgencia passou
       * a ser `ativo: false`, que e um update. Sem isto, a urgencia cancelada
       * ficava na lista ate alguem recarregar a pagina. */
      if (parsedSocketData.tabela === "urgencias") {
        recarregarUrgencias();
      }

      if (
        parsedSocketData.tabela === "notificacaos" &&
        parsedSocketData.documento.user === auth.userId
      ) {
        const fetchcliente = async () => {
          try {
            const responseData = await sendRequest(
              `${process.env.REACT_APP_BACKEND_LINK}/api/clientes/${parsedSocketData.documento.cliente}?clinicaId=${clinica.clinica._id}`,
              "GET",
              null,
              {
                Authorization: "Bearer " + auth.token,
              }
            );

            if (parsedSocketData.documento.tipo === "avaliação") {
              setAvaliacoesPorEfetuar((current) => [
                ...current,
                {
                  idCliente: responseData.cliente.id,
                  cliente: responseData.cliente.nome,
                  created_at: parsedSocketData.documento.created_at,
                  id: parsedSocketData.id,
                },
              ]);
            }
          } catch (err) {}
        };

        fetchcliente();
      }

      if (parsedSocketData.tabela === "listapresencas") {
        const fetchListaPresenca = async () => {
          try {
            const responseData = await sendRequest(
              `${process.env.REACT_APP_BACKEND_LINK}/api/listapresenca/${clinica.clinica._id}`,
              "GET",
              null,
              {
                Authorization: "Bearer " + auth.token,
              }
            );
            setListaPresenca(responseData.listaPresenca);
          } catch (err) {}
        };
        fetchListaPresenca();
      }
    },
    [clinica.clinica._id, sendRequest, recarregarUrgencias],
    "Dashboard"
  );

  useEffect(() => {
    const fetchEstatisticaProcedimentos = async () => {
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/planostratamento/dashboardadministrador/estatisticaprocedimentos/${auth.userId}`,
          "GET",
          null,
          {
            Authorization: "Bearer " + auth.token,
          }
        );
        setEstatisticaProcedimentos(responseData.listaProcedimentos);
      } catch (err) {
        console.error("err", err);
      }
    };

    fetchEstatisticaProcedimentos();

    recarregarUrgencias();

    const fetchAvaliacoesPorEfetuar = async () => {
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/notificacoes/clinica/${clinica.clinica._id}/${auth.userId}`,
          "GET",
          null,
          {
            Authorization: "Bearer " + auth.token,
          }
        );
        const avalList = [];
        responseData.notificacoes.forEach((n) => {
          if (n.tipo === "avaliação") {
            avalList.push({
              id: n.id,
              idCliente: n.cliente.id,
              cliente: n.cliente.nome,
              created_at: n.created_at,
            });
          }
        });
        setAvaliacoesPorEfetuar(avalList);
      } catch (err) {}
    };
    fetchAvaliacoesPorEfetuar();

    const fetchListaPresenca = async () => {
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/listapresenca/${clinica.clinica._id}`,
          "GET",
          null,
          {
            Authorization: "Bearer " + auth.token,
          }
        );
        setListaPresenca(responseData.listaPresenca);
      } catch (err) {}
    };
    fetchListaPresenca();
  }, [
    sendRequest,
    auth.userId,
    clinica,
    auth.token,
    recarregarUrgencias,
  ]);

  //MODAL Urgencia
  const handleOpen = (tipo) => {
    if (tipo === "urgencia") {
      /* Abre com qualquer urgencia na lista, atendida ou nao: ela deixou de
         ser so a fila e passou a ser o dia.
         `urgencias` pode ser `undefined` antes da primeira resposta — sem o
         `?.`, clicar em «Mais» durante o carregamento rebentava em silencio e
         parecia que o botao nao fazia nada. */
      if (urgencias?.length > 0) setOpenModalUrgencia(true);
    }
    if (tipo === "avaliacao") {
      if (avaliacoesPorEfetuar.length > 0)
        setOpenModalAvaliacoesPorEfetuar(true);
    }
  };

  const handleClose = () => {
    setOpenModalUrgencia(false);
    setOpenModalAvaliacoesPorEfetuar(false);
  };

  //Codigo para marcar cliente como atendido
  const handleAtendido = async (id) => {
    try {
      startLoading();
      await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/urgencias/atendido/${id}`,
        "PATCH",
        {},
        {
          Authorization: "Bearer " + auth.token,
        }
      );

      /* Recarregar, e nao filtrar fora: no escopo do dia a urgencia FICA na
         lista, agora marcada como atendida e com o nome de quem a assumiu. */
      await recarregarUrgencias();

      toast.success("Urgência sua. A equipa deixou de ser avisada.");
      handleModalCancel();
    } catch (err) {
      console.error("err", err);
    } finally {
      stopLoading();
    }
  };

  const handleModalCancel = () => {
    setModalProps((currentModalProps) => {
      return { ...currentModalProps, show: false };
    });
  };

  const atendidoConfirmation = (id, nome) => {
    setOpenModalUrgencia(false);
    setModalProps({
      show: true,
      icon: "info",
      title: `Urgência`,
      message: `Confirma que vai atender ${nome} agora? A urgência sai da fila e deixa de avisar a equipa.`,
      form: true,
      onCancel: handleModalCancel,
      onConfirm: handleAtendido.bind(null, id),
    });
  };

  /* Tirar da fila sem atender: o doente foi embora, ou foi marcada por engano.
     Grava o mesmo que o «Cancelar Urgencia» da ficha do cliente — ver
     `dispensarUrgencia` no servidor. Nao apaga: continua na lista do dia,
     marcada como dispensada. */
  /* O motivo e pedido num modal proprio: o `ModalInfo` so tem sim/nao e nao
     recolhe nada. Sem motivo, «Dispensada» no relatorio nao se interpreta. */
  const handleDispensar = async ({ motivoDispensa, notaDispensa }) => {
    if (!aDispensar) return;
    setDispensando(true);
    try {
      await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/urgencias/dispensar/${aDispensar.id}`,
        "PATCH",
        JSON.stringify({ motivoDispensa, notaDispensa }),
        {
          "Content-Type": "application/json",
          Authorization: "Bearer " + auth.token,
        }
      );
      await recarregarUrgencias();
      toast.success("Urgência dispensada.");
      setADispensar(null);
    } catch (err) {
      toast.error(err.message || "Não foi possível dispensar a urgência.");
    } finally {
      setDispensando(false);
    }
  };

  const dispensarConfirmation = (id, nome) => {
    setOpenModalUrgencia(false);
    setADispensar({ id, nome });
  };

  const avaliacaoDispensada = (id) => {
    const tempAvaliacoes = avaliacoesPorEfetuar.filter((av) => av.id !== id);
    setAvaliacoesPorEfetuar(tempAvaliacoes);
  };

  ///////////////////////////////////////////////////

  const showSinglePage = () => {
    if (listaAtendimentoData.show)
      setListaAtendimentoData((current) => {
        return { ...current, show: false };
      });
  };

  const visualizarPdf = (lista, incluirObservacoes, unidade) => {
    setListaAtendimentoData({
      show: true,
      data: lista,
      dataLista: lista[0].data_inicio_execucao,
      incluirObservacoes: incluirObservacoes,
      // De que unidade é a lista. Vazio nas clínicas de unidade única.
      unidade,
    });
  };

  return (
    <>
      {listaAtendimentoData.show && (
        <PdfListaAtendimentos
          showPreviousPage={showSinglePage}
          listaAtendimentoData={listaAtendimentoData.data}
          medico={auth.nome}
          clinica={clinica.clinica.nome}
          unidade={listaAtendimentoData.unidade}
          dataLista={moment(listaAtendimentoData.dataLista).format(
            "DD-MM-YYYY"
          )}
          incluirObservacoes={listaAtendimentoData.incluirObservacoes}
        />
      )}
      {!listaAtendimentoData.show && (
        <>
          <div className="home">
            <Sidebar />
            <div className="homeContainer">
              <Navbar
                title="dashboard"
                icon={DashboardIcon}
                avaliacaoDispensada={avaliacaoDispensada}
              />
              <div className="dashboard__ola">
                <span className="dashboard__ola__big">{`Olá, ${
                  auth.genero === "feminino" ? "Dra. " : "Dr. "
                }${auth.nomeAbreviado}!`}</span>
                <span className="dashboard__ola__small">
                  {DAILY_MESSAGES[new Date().getDate() - 1] || ""}
                </span>
              </div>
              <ModalInfo {...modalProps} />

              {openModalUrgencia && (
                <UrgenciasModal
                  handleClose={handleClose}
                  atendidoConfirmation={atendidoConfirmation}
                  aoDispensar={dispensarConfirmation}
                  urgencias={urgencias}
                  openModalUrgencia={openModalUrgencia}
                  escopo="dia"
                />
              )}

              {/* FORA do `openModalUrgencia`: dispensar fecha a lista primeiro,
                  e aqui dentro este modal nunca chegava a aparecer. */}
              <ModalDispensarUrgencia
                aberto={!!aDispensar}
                fechar={() => setADispensar(null)}
                nomeCliente={aDispensar?.nome}
                aoConfirmar={handleDispensar}
                aEnviar={dispensando}
              />
              {openModalAvaliacoesPorEfetuar && (
                <AvaliacoesPorEfetuarModal
                  handleClose={handleClose}
                  avaliacoesPorEfetuar={avaliacoesPorEfetuar}
                  openModalAvaliacoesPorEfetuar={openModalAvaliacoesPorEfetuar}
                />
              )}
              <div className="dashboard__top">
                {estatisticaDeProcedimentos && (
                  <Chart
                    nome={auth.nomeAbreviado}
                    genero={auth.genero}
                    role={auth.role}
                    data={estatisticaDeProcedimentos}
                  />
                )}

                <div className="caixa dashboard__right">
                  <div className="dashboard__right__top">
                    <div className="dashboard__right__top-left">
                      <span className="box-title">Avaliações</span>
                      <div className="info-planos-tratamento">
                        <span className="big-numbers">
                          {avaliacoesPorEfetuar.length}
                        </span>
                        <span className="medium-gray-text">por efetuar</span>
                      </div>
                      <div
                        className="button-more-div"
                        onClick={handleOpen.bind(null, "avaliacao")}
                      >
                        <span className="button-more">Mais</span>
                        <span className="more-arrow"> {">"} </span>
                      </div>
                    </div>
                    {urgencias && (
                      <div className="dashboard__right__top-right">
                        <span
                          className={`box-title ${
                            urgenciasPendentes.length > 0 && `urgencia`
                          }`}
                        >
                          Urgências de Hoje
                        </span>
                        <span
                          className={`big-numbers ${
                            urgenciasPendentes.length > 0 && `urgencia`
                          }`}
                        >
                          {urgenciasPendentes.length}
                        </span>
                        <div
                          className="button-more-div"
                          onClick={handleOpen.bind(null, "urgencia")}
                        >
                          <span
                            className={`button-more ${
                              urgenciasPendentes.length > 0 && `urgencia`
                            }`}
                          >
                            Mais
                          </span>
                          <span
                            className={`more-arrow ${
                              urgenciasPendentes.length > 0 && `more-arrow--urgencia`
                            }`}
                          >
                            {">"}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                  <hr />
                  <InformacoesDaClinica
                    sendRequest={sendRequest}
                    auth={auth}
                    clinica={clinica}
                  />
                </div>
              </div>

              <div className="listContainer caixa">
                {clinica.clinica.configuracoes.configuracoes.tipoAgendamento
                  .tipo === "Tratamento" ? (
                  <ProcedimentosTratamento
                    visualizarPdf={visualizarPdf}
                    listaPresencaProp={listaPresenca}
                  />
                ) : (
                  <Procedimentos
                    visualizarPdf={visualizarPdf}
                    listaPresencaProp={listaPresenca}
                  />
                )}
              </div>

              <div className="dashboard__bottom caixa tasks__container">
                <Tasks
                  clinica={clinica}
                  auth={auth}
                  sendRequest={sendRequest}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default HomeMedicoAdministrador;
